import React, { useState, useEffect } from "react";
import {
  CustomBoxContentLink,
  CustomBoxTableOfContent,
  CustomTypography,
  StyledFiberManualRecord,
} from "./tableOfcontent.style";
import { Box } from "@mui/material";

const TableOfContents = ({
  sections,
  activeSection,
  scrollToSection,
  isMobile,
}) => {
  const LinkColor = isMobile ? "blue" : "#817a99"; 
  const TableOfContentStyle = isMobile ? { overflowY: "visible", maxHeight: "unset" } : {};
  return (
    <CustomBoxTableOfContent style={TableOfContentStyle}>
      {sections.map((section) => (
        <Box key={section.id} style={{ display: "flex" }}>
          {section.type === "heading2" || section.type === "heading3" ? (
            <CustomBoxContentLink
              onClick={(event) => scrollToSection(event, section.id)}
              style={{
                marginLeft: section.type === "heading3" ? "38px" : "0",
                color: activeSection === section.id ? "#160647" : LinkColor,
              }}
            >
              {section.type === "heading2" && isMobile && (
                <StyledFiberManualRecord
                  viewBox="0 0 24 20"
                  style={{
                    marginRight: section.type === "heading3" ? "16px" : "-4px",
                    color: activeSection === section.id ? "#160647" : LinkColor,
                  }}
                >
                  <circle cx="8" cy="8" r="4" />
                </StyledFiberManualRecord>
              )}
              <CustomTypography
                component="a"
                href={`#${section.id}`}
                onClick={(event) => scrollToSection(event, section.id)}
                style={{
                  color: activeSection === section.id ? "#160647" : LinkColor,
                }}
              >
                {section.title}
              </CustomTypography>
            </CustomBoxContentLink>
          ) : null}
        </Box>
      ))}
    </CustomBoxTableOfContent>
  );
};
export default TableOfContents;
